"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPartTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _HttpStatus = require("../../constants/HttpStatus");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _Share = _interopRequireDefault(require("@mui/icons-material/Share"));
var _DmsPartParameterValueModal = require("../DmsPartParameterValue/DmsPartParameterValueModal");
var _material = require("@mui/material");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
* Description: This component is the DMS roles page
* Props: none
*/
const DmsPartTable = () => {
  const table = (0, _react.useRef)(null);
  const [selectedRowData, setSelectedRowData] = (0, _react.useState)("");
  const [modalPartParameters, setModalPartParameters] = (0, _react.useState)(false);
  const handleShowPartParameters = row => {
    setSelectedRowData(row);
    setModalPartParameters(true);
  };
  const header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Number").d("Number"),
    column_name: "number",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("PartParameters").d("Part parameters"),
    column_name: "pk",
    width: "5vw",
    sortable: false,
    can_create: false,
    can_edit: false,
    element: row => /*#__PURE__*/_react.default.createElement(_material.Chip, {
      label: _reactIntlUniversal.default.get("Parameters").d("Parameters"),
      onClick: () => handleShowPartParameters(row),
      icon: /*#__PURE__*/_react.default.createElement(_Share.default, {
        sx: {
          color: "#FFFFFF !important"
        }
      }),
      sx: {
        minWidth: "8vw",
        color: "#FFFFFF",
        backgroundColor: "#468499",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        ":hover": {
          backgroundColor: "#5B9DB3"
        }
      }
    })
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    column_name: "actions",
    permissions: [_Permissions.Permissions.CAN_EDIT_PART],
    width: "80px",
    sortable: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Updatepart_name", {
          name
        }).d("Update {name}"),
        url: "/part/",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Deletepart_name", {
          name
        }).d("Delete {name}"),
        text: _reactIntlUniversal.default.get("DmsPartTable.DeleteButtonMessage", {
          name
        }).d("The part {name} will be deleted. Are you sure about it?"),
        url: "/part/",
        row_pk: row.pk
      }));
    }
  }];
  const createPart = async data => {
    const url = "/part";
    const response = await (0, _DmsFetch.fetchData)(url, "POST", true, data);
    if (response.status === _HttpStatus.HTTP_STATUS.CREATED_201) {
      _sweetalert.default.fire({
        icon: "success",
        title: _reactIntlUniversal.default.get("PartCreated").d("Part Created")
      });
      table.current.updateTable();
    } else {
      var _response$data;
      _sweetalert.default.fire({
        icon: "error",
        title: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.detail
      });
    }
  };
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    header: header,
    table: table,
    title: _reactIntlUniversal.default.get("Createpart").d("Create part"),
    handler: createPart
  }))));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    export_table: false,
    ref: table,
    url: '/part/table',
    toolbar: toolbar
  }), /*#__PURE__*/_react.default.createElement(_DmsPartParameterValueModal.DmsPartParameterValueModal, {
    table: table,
    show: modalPartParameters,
    row_data: selectedRowData,
    onHide: () => setModalPartParameters(false)
  }));
};
exports.DmsPartTable = DmsPartTable;